import type { SDSTextType } from '@repo/sds/components/SDSText';
import { SDSText } from '@repo/sds/components/SDSText';

import '@repo/sds/components/SDSInputLabel/SDSInputLabel.scss';

export interface SDSInputLabelProps {
  id?: string;
  label?: string;
  isRequired?: boolean;
  textType?: SDSTextType;
}

export function SDSInputLabel({ id, label, isRequired = false, textType = 'body-large' }: SDSInputLabelProps) {
  if (!label) return null;

  return (
    <div className="SDSInputLabel" id={id}>
      <SDSText text={label} type={textType} />
      {isRequired && <span className="SDSInputLabel__required">*</span>}
    </div>
  );
}
